import { render, staticRenderFns } from "./OrdenesVentaIncompletas.vue?vue&type=template&id=9a00faa4&"
import script from "./OrdenesVentaIncompletas.vue?vue&type=script&lang=js&"
export * from "./OrdenesVentaIncompletas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports